'use client'

import { MantineProvider } from '@mantine/core'
import { cssVariablesResolver, theme } from '@lib/theme'
import AppDatesProvider from './AppDatesProvider'

interface AppMantineProviderProps {
    children: React.ReactNode
}

export default function AppMantineProvider({ children }: AppMantineProviderProps) {
    return (
        <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver} forceColorScheme='light'>
            <AppDatesProvider>{children}</AppDatesProvider>
        </MantineProvider>
    )
}
